import React from "react";
import { connect } from "react-redux";
import { leaveRoom, hostLeaveMeeting } from "../../utils/wss";

const LeaveRoomButton = ({ isRoomHost, roomId }) => {
  const handleRoomDisconnection = () => {
    // If host is leaving, notify all participants
    if (isRoomHost) {
      hostLeaveMeeting(roomId, isRoomHost);
    }
    leaveRoom();
    // Redirect to home or login page
    window.location.href = window.location.origin;
  };

  return (
    <div
      className="video_button_container leave_button tooltip"
      onClick={handleRoomDisconnection}
      data-tooltip="Leave Meeting"
      style={{ marginLeft: '20px' }}
    >
      <span className="video_button_icon" style={{ color: '#e03e3e' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      </span>
      <span className="video_button_label" style={{ color: '#e03e3e' }}>Leave</span>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isRoomHost: state.isRoomHost,
    roomId: state.roomId,
  };
};

export default connect(mapStateToProps)(LeaveRoomButton);
